import styled from "styled-components";

export const StyledCustomRadioLabelWrapper = styled.div`
    // Remove default margin between radio blocks
    > span {
        margin-bottom: 0;
    }
`;
